import React from 'react';
import { View } from "react-native";
import { ThemedValues } from 'styles/themed'

const style = {
	marginHorizontal: -ThemedValues.marginHorizontal,
};

const ThemedBlockListContainer = ({ children, ...props }) => {
	
	return (
		<View
			style={[
				style,
			]}>
			
			{ children }
		</View>
	)
}

export default ThemedBlockListContainer
